import { render, staticRenderFns } from "./QuickScanDetails.vue?vue&type=template&id=f48593fc&scoped=true&"
import script from "./QuickScanDetails.vue?vue&type=script&lang=js&"
export * from "./QuickScanDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuickScanDetails.vue?vue&type=style&index=0&id=f48593fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48593fc",
  null
  
)

export default component.exports